import { useIntl } from 'react-intl';
import SearchIcon from '../../assets/icons/table/search.svg';
import './Searchbar.css';

function Searchbar({
  search,
  value,
  placeholder="SEARCH",
}) {
  const intl = useIntl();
  const t = (id) => intl.formatMessage({ id });
  return (
    <div id="search" className="form-outline search-container">
      <input
        id="searchInput"
        className="form-control"
        type="search"
        placeholder={t(placeholder)}
        value={value}
        onChange={(e) => { search(e.target.value) }}
      />
			<img src={SearchIcon} className="searchIcon" alt="Search Icon" />
    </div>
  );
}

export default Searchbar;